import { createRouter, createWebHistory } from "vue-router"

import Dashboard from "@/components/pages/Dashboard"
import Tools from "@/components/pages/tools"
import TekenaarsOld from "@/components/pages/Tekenaars"
import Tekenaars from "@/views/Tekenaars"
import Kaart from "@/components/pages/kaart"
import Opdrachten from "@/components/pages/Opdrachten"

const routes = [
  {
    path: "/",
    name: "Dashboard",
    component: Dashboard
  },
  {
    path: "/tools",
    name: "Tools",
    component: Tools,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: "/tekenaars",
    name: "Tekenaars",
    component: Tekenaars,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/tekenaars-oud",
    name: "Tekenaars Oud",
    component: TekenaarsOld,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/kaart",
    name: "kaart",
    component: Kaart,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/opdrachten",
    name: "Opdrachten",
    component: Opdrachten,
    meta: {
      requiresAuth: true
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
